"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function JoinTheNextRetreat() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const countdownData = [{
    label: "Vol.",
    value: "2024"
  }, {
    label: "Issues",
    value: "08"
  }, {
    label: "Updates",
    value: "12"
  }];
  return <section data-section-id="128084" id="subscribe-to-newsletter" className="bg-background py-24 sm:py-32 relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        
      </div>
    </section>;
}